<!-- <script src="js/flexible.js"></script>
<script src="js/jquery.js"></script>
<script src="js/echarts.min.js"></script>
<script src="js/index.js"></script>
<script src="js/china.js"></script>
<script src="js/myMap.js"></script> -->

<template>
  <body id="bodytest">
    <header>
      <h1>大白数字家医隐私政策</h1>
      <!-- <div class="subtitle">开发者：大白主动健康科技（南京）有限公司</div>
      <div class="subtitle">运营者：大白主动健康科技（南京）有限公司</div> -->
      <div class="date-info">开发者：大白主动健康科技（南京）有限公司</div>
      <div class="date-info">运营者：大白主动健康科技（南京）有限公司</div>
      <div class="date-info">
        生效日期：2025年8月19日 | 最后更新：2025年8月19日
      </div>
    </header>

    <!-- <div class="section">
      <h2>详情</h2>
      <h3>【大白数字家医】是大白主动健康科技（南京）有限公司（以下简称“我们”）开发的一款定位为“虚拟AI家庭医生智能体平台”的软件。为了给您提供更准确、更有个性化的服务，本软件会按照本《隐私政策》的规定使用您的个人信息。</h3>
      <h3>为了保证对您的个人隐私信息合法、适度的收集、使用，并在安全、可控的情况下进行传输、存续，如果您就本《隐私政策》点击或勾选“同意”并确认提交，则表示您已充分理解并同意本《隐私政策》，并同意我们按照本《隐私政策》手机、使用、储存、（特定情形下）分享和转让您的相关信息</h3>
      <h3>若您是12周岁以上的未成年人，请在监护人的陪同下阅读本政策，并确保您和您的监护人充分理解并确认本政策的所有内容，方可使用本软件，若您为12周岁一下的未成年人，请不要使用本软件的任何服务，如对本政策内容有任何疑问、意见或建议，您可通过本隐私政策中后文提供的联系方式与我们联系。</h3>
    </div>

    <div class="section">
      <h2>本《隐私政策》将帮助您了解以下十一项内容：</h2>
      <h3>1. 为了方便你的蓝牙设备连接，我们将在搜索附近蓝牙设备时收集您的设备位置信息，您若不使用相关功能有权拒绝授权；</h3>
      <h3>2. 为了确保会员制度的实现，在相关功能场景里，基于您的授权我们将收集您的账号信息、第三方支付信息等，您若不使用相关功能有权拒绝授权；</h3>
      <h3>3. 为了您发布体检报告时上传或拍摄图片或视频,或是下载图片或视频，或是更换头像等，我们将向您请求打开照相机权限、相册权限、SD卡权限，您若不使用相关功能有权拒绝授权；</h3>
      <h3>4. 当您使用咨询功能时，如果您使用语音咨询功能，此时我们会请求拨打电话权限、麦克风权限；</h3>
      <h3>5.当您分享信息到第三方应用以及使用极光统计SDK时，我们会获取您的设备的mac地址,androidID，以及软件安装列表;</h3>
      <h3>6.当您使用登录功能时，为了获取到您的手机号码进行快速登录或验证码登录，我们将向您请求打开获取短信，拨打电话和管理通话权限，同时会收集您的手机ISMI信息，您若不使用相关功能有权拒绝授权；</h3>
      <h3>7.我们使用的极光SDK，会在运行中【获取Wi-Fi SSID、获取Wi-Fi BSSID】以确保程序可以正常运行；</h3>
      <h3>8.APP内提供账号注销功能，具体操作如下:首页->系统设置->注销账户；如若您不想要开启某些功能时，您可以在系统中撤回授权，如通过设置->应用管理->大白数字家医->权限来关闭对应相关权限；</h3>
    </div> -->

    <div class="section">
      <h2>详情</h2>
      <!-- <p>【大白数字家医】是大白主动健康科技（南京）有限公司（以下简称“我们”）开发的一款定位为“虚拟AI家庭医生智能体平台”的软件。为了给您提供更准确、更有个性化的服务，本软件会按照本《隐私政策》的规定使用您的个人信息。</p> -->
      <p>【大白数字家医】是大白主动健康科技（南京）有限公司（以下简称“我们”）开发的一款定位为“虚拟AI家庭医生智能体平台”的软件。本软件会按照本《隐私政策》的规定使用您的个人信息。</p>
      <p>为了保证对您的个人隐私信息合法、适度的收集、使用，并在安全、可控的情况下进行传输、存续，如果您就本《隐私政策》点击或勾选“同意”并确认提交，则表示您已充分理解并同意本《隐私政策》，并同意我们按照本《隐私政策》手机、使用、储存、（特定情形下）分享和转让您的相关信息</p>
      <p>若您是12周岁以上的未成年人，请在监护人的陪同下阅读本政策，并确保您和您的监护人充分理解并确认本政策的所有内容，方可使用本软件，若您为12周岁一下的未成年人，请不要使用本软件的任何服务，如对本政策内容有任何疑问、意见或建议，您可通过本隐私政策中后文提供的联系方式与我们联系。</p>
    </div>

    <div class="section">
      <h2>本《隐私政策》将帮助您了解以下十一项内容：</h2>
      <p>1. 为了方便你的蓝牙设备连接，我们将在搜索附近蓝牙设备时收集您的设备位置信息，您若不使用相关功能有权拒绝授权；</p>
      <p>2. 为了确保会员制度的实现，在相关功能场景里，基于您的授权我们将收集您的账号信息、第三方支付信息等，您若不使用相关功能有权拒绝授权；</p>
      <p>3. 为了您发布体检报告时上传或拍摄图片或视频,或是下载图片或视频，或是更换头像等，我们将向您请求打开照相机权限、相册权限、SD卡权限，您若不使用相关功能有权拒绝授权；</p>
      <p>4. 当您使用咨询功能时，如果您使用语音咨询功能，此时我们会请求拨打电话权限、麦克风权限；</p>
      <p>5.当您分享信息到第三方应用以及使用极光统计SDK时，我们会获取您的设备的mac地址,androidID，以及软件安装列表;</p>
      <p>6.当您使用登录功能时，为了获取到您的手机号码进行快速登录或验证码登录，我们将向您请求打开获取短信，拨打电话和管理通话权限，同时会收集您的手机ISMI信息，您若不使用相关功能有权拒绝授权；</p>
      <p>7.我们使用的极光SDK，会在运行中【获取Wi-Fi SSID、获取Wi-Fi BSSID】以确保程序可以正常运行；</p>
      <p>8.我们使用加速度传感器,电话状态权限以便更好的使用通话咨询功能。</p>
      <p>9.我们使用 [Aliyun Common] SDK获取用户加速度传感器信息，以便运动功能正常使用</p>
      <p>10.APP内提供账号注销功能，具体操作如下:首页->系统设置->注销账户；</p>
      <p>11.为了给您提供更好的服务，我们在使用过程中可能会出现关联启动其他App的场景；</p>
      <p>如若您不想要开启某些功能时，您可以在系统中撤回授权，如通过设置->应用管理->大白数字家医->权限来关闭对应相关权限；</p>
    </div>

    <footer>
      <h2>联系我们</h2>
      <div class="contact-methods">
        <div class="contact-item">
          <h3>隐私保护官邮箱</h3>
          <p>zch888@139.com</p>
        </div>
        <div class="contact-item">
          <h3>客服电话</h3>
          <p>15895887135（工作日9:00-18:00）</p>
        </div>

        <div class="contact-item">
          <h3>在线客服</h3>
          <p>APP内「我的-帮助中心」</p>
        </div>
        <div class="contact-item">
          <h3>公司相关</h3>
          <p>大白主动健康科技（南京）有限公司</p>
          <p>南京市鼓楼区汉中门大街301号外包服务大厦AB座12层1212室</p>
        </div>
      </div>
      <!-- <div class="legal-notes">
        <h3>法律声明要点</h3>
        <ul>
          <li>健康分析报告非医疗诊断结论，仅供参考</li>
          <li>用户需保证设备数据采集符合自身健康状况</li>
          <li>因用户主动共享密码导致的数据泄露，平台不承担责任</li>
        </ul>
      </div> -->
    </footer>

  </body>
</template>

<script>
export default {
  data() {
    return {
      effectiveDate: "2025年6月27日",
      lastUpdated: "2025年6月27日",
      showBackToTop: false,
      sections: [
        { title: "一、我们收集的信息类型" },
        { title: "二、信息使用方式与目的" },
        { title: "三、数据存储与安全" },
        { title: "四、第三方共享规则" },
        { title: "五、您的权利" },
        { title: "六、儿童特别保护" },
        { title: "七、协议更新" },
      ],
      agreementStatus: null,
    };
  },
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    acceptAgreement() {
      this.agreementStatus = {
        message: "您已成功同意隐私协议！",
        icon: "fas fa-check-circle",
        type: "success-status",
      };
    },
    declineAgreement() {
      this.agreementStatus = {
        message: "您需要同意隐私协议才能继续使用我们的服务",
        icon: "fas fa-exclamation-triangle",
        type: "error-status",
      };
    },
    handleScroll() {
      this.showBackToTop = window.scrollY > 300;
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    this.handleScroll();
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style scoped>
#app {
  height: max-content;
}

#bodytest {
  height: 100vh;
  overflow-y: auto;
}

body {
  background-color: #f0f8ff;
  color: #333;
  line-height: 1.6;
  padding: 20px;
}

table {
  width: 100%;
  border-collapse: collapse;
  margin: 20px 0;
  background: #fff;
  border: 1px solid #ddd;
}

th,
td {
  padding: 12px 15px;
  text-align: left;
  border: 1px solid #ddd;
}
</style>

<style>

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Segoe UI", "PingFang SC", "Microsoft YaHei", sans-serif;
}

/* body {
  background-color: #f0f8ff;
  color: #333;
  line-height: 1.6;
  padding: 20px;
} */

.container {
  max-width: 1000px;
  margin: 0 auto;
  background: white;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  padding: 30px;
}

header {
  text-align: center;
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 2px solid #0066cc;
}

h1 {
  font-size: 2.2rem;
  color: #0066cc;
  margin-bottom: 10px;
}

.subtitle {
  font-size: 1.2rem;
  color: #666;
  margin-bottom: 15px;
}

.date-info {
  color: #666;
  font-size: 0.95rem;
}

.toc {
  background: #f5f9ff;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 30px;
}

.toc h2 {
  color: #0066cc;
  margin-bottom: 15px;
  font-size: 1.4rem;
}

.toc ul {
  list-style-type: none;
}

.toc li {
  margin-bottom: 10px;
  padding-left: 20px;
  position: relative;
}

.toc li:before {
  content: "•";
  position: absolute;
  left: 0;
  color: #0066cc;
  font-weight: bold;
}

.toc a {
  color: #0066cc;
  text-decoration: none;
}

.toc a:hover {
  text-decoration: underline;
}

.section {
  margin-bottom: 40px;
}

.section h2 {
  color: #0066cc;
  font-size: 1.6rem;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e0e0e0;
}

.section h3 {
  color: #1a3a5a;
  font-size: 1.3rem;
  margin: 25px 0 15px;
}

p {
  margin-bottom: 15px;
  line-height: 1.7;
}

/* table {
  width: 100%;
  border-collapse: collapse;
  margin: 20px 0;
  background: #fff;
  border: 1px solid #ddd;
}

th,
td {
  padding: 12px 15px;
  text-align: left;
  border: 1px solid #ddd;
} */

th {
  background-color: #e6f2ff;
  color: #0066cc;
  font-weight: 600;
}

tr:nth-child(even) {
  background-color: #f9f9f9;
}

.highlight-box {
  background: #fffde7;
  border-left: 4px solid #ffcc00;
  padding: 15px;
  margin: 20px 0;
  border-radius: 0 4px 4px 0;
}

.security-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin: 20px 0;
}

.security-layer {
  background: #f0f8ff;
  padding: 20px;
  border-radius: 8px;
  border: 1px solid #cce0ff;
}

.security-layer h4 {
  color: #1a3a5a;
  margin-bottom: 10px;
}

.retention-list {
  list-style-type: none;
  margin: 20px 0;
}

.retention-list li {
  margin-bottom: 15px;
  padding-left: 25px;
  position: relative;
}

.retention-list li:before {
  content: "•";
  position: absolute;
  left: 10px;
  color: #0066cc;
  font-weight: bold;
}

.consent-box {
  background: #f0f8ff;
  padding: 25px;
  border-radius: 8px;
  margin: 30px 0;
  text-align: center;
  border: 1px solid #cce0ff;
}

.consent-box h3 {
  color: #0066cc;
  margin-bottom: 20px;
}

.consent-actions {
  margin-top: 20px;
}

footer {
  margin-top: 40px;
  padding-top: 30px;
  border-top: 2px solid #0066cc;
}

footer h2 {
  color: #0066cc;
  text-align: center;
  margin-bottom: 25px;
}

.contact-methods {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
}

.contact-item {
  background: #f0f8ff;
  padding: 20px;
  border-radius: 8px;
}

.contact-item h3 {
  color: #1a3a5a;
  margin-bottom: 10px;
}

.legal-notes {
  background: #fffde7;
  padding: 20px;
  border-radius: 8px;
  margin-top: 30px;
}

.legal-notes h3 {
  color: #1a3a5a;
  margin-bottom: 15px;
}

.legal-notes ul {
  list-style-type: none;
}

.legal-notes li {
  margin-bottom: 10px;
  padding-left: 25px;
  position: relative;
}

.legal-notes li:before {
  content: "•";
  position: absolute;
  left: 10px;
  color: #0066cc;
  font-weight: bold;
}

@media (max-width: 768px) {
  .container {
    padding: 20px;
  }

  h1 {
    font-size: 1.8rem;
  }

  .section h2 {
    font-size: 1.4rem;
  }

  .section h3 {
    font-size: 1.2rem;
  }

  .security-grid,
  .contact-methods {
    grid-template-columns: 1fr;
  }
}
</style>
